import Vue from "vue"
import App from "./App.vue"
import router from "./router/index"
import store from "./store"
import BootstrapVue from "bootstrap-vue"
import Vuelidate from 'vuelidate'
// eslint-disable-next-line
import Toast from 'vue-easy-toast'
import VuePaginate from 'vue-paginate'
import VueSweetalert2 from 'vue-sweetalert2'
import VCalendar from 'v-calendar'
import FunctionalCalendar from 'vue-functional-calendar'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import filters from './helpers/filters';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import ToggleButton from 'vue-js-toggle-button'

import 'material-design-icons-iconfont'

Vue.component('v-select', vSelect)
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
// eslint-disable-next-line
//Vue.config.devtools = true
Vue.use(filters);
Vue.use(ToggleButton)
Vue.use(VCalendar, {
  
})
Vue.use(VueSweetalert2)
Vue.use(VuePaginate)
Vue.use(Toast)
Vue.use(Vuelidate)
// Vue.use(VueIziToast)
Vue.use(BootstrapVue)

Vue.use(FunctionalCalendar, {
  dayNames: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
  shortMonthNames: ['Jan', 'Fev', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
})
Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

// Directive pour empecher le drap & drop, source d'erreur lorsque l'on travail sur la page
Vue.directive('no-dragdrop', {
  inserted(el) {
    el.setAttribute('draggable', 'false');

    el.addEventListener('dragstart', (e) => e.preventDefault());
    el.addEventListener('dragover', (e) => e.preventDefault());
    el.addEventListener('drop', (e) => e.preventDefault());

    /* Pour corriger un bug, il arrive que le texte sélectionné, via un drag & drop, se relache sur un autre champ */
    /* quand un dragstart se produit, on force le blur() de tous les inputs ! */
    document.addEventListener('dragstart', () => {
      const active = document.activeElement;
      if (active && active.tagName === 'INPUT') {
        active.blur(); // On retire le focus à l'input actif
      }
    });
  }
});

Object.defineProperty(Array.prototype, 'first', {
  value() {
    if (!this.length)
      return null
    return this[0]
  }
})
Object.defineProperty(Array.prototype, 'last', {
  value() {
    if (!this.length)
      return null
    return this[this.length - 1]
  }
})

new Vue({ router, store, render: h => h(App) }).$mount("#app")
